import React, { Component } from "react";
import "./Dropzone.css";
import styled from 'styled-components';
import {FiDownload} from 'react-icons/fi'
import {MdClear} from 'react-icons/md'
import { saveAs } from 'file-saver';
import APICall from '../../Common/APICall';
import Store from '../../Common/Store.js';

const FileContainer = styled.div`
    width: 300px;
    display: flex;
`;
const FileInfoContainer = styled.div`
    margin-left:10px;
    color: #969EA2;
    width: 220px;
    height: 70px;
`;
const FileTypeContainer = styled.div`
    width: 100px;
    min-height:70px;
    height: 70px;
    background-color: #fff;
    color: #969EA2;
    font-size:22px;
    text-align:center;
    padding-top:22px;
    font-weight:800;
    border: 1px solid #AA9EA2;
`;
const UploadButton = styled.button`
    box-sizing: border-box;
    background-color: #234062;
    color: #AAB6C3;
    border: 1px solid #37ada7;
    width: 200px;
    font-size: 13px;
    height: 45px;
    border-radius: 3px;
    margin-left:36px;
    margin-top:21px;
    cursor:pointer;
`;
const default_profile_pic = "data:image/png;base64,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" ;

class Dropzone extends Component {

  state = {files: [], bin_files: [], image_bin: default_profile_pic};
  binFiles = [];
  numFiles = 0;
  prevNumFiles = 0;
  numFilesLoading = 0;

  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();

    this.openFileDialog = this.openFileDialog.bind(this);
    this.onFilesAdded = this.onFilesAdded.bind(this);
  }

  openFileDialog() {
    if (this.props.disabled) return;
    this.fileInputRef.current.click();
  }

  updateProgress = (evt) => {
    if (evt.lengthComputable) {
      var percentLoaded = Math.round((evt.loaded / evt.total) * 100);
    }
  }

  readBinaryFile = (file) => {
    let reader = new FileReader();
    let that = this;
    reader.onprogress = this.updateProgress;
    reader.onload = (function(theFile) {
      return function(e) {
        let fElement = {name: theFile.name, bin_file: window.btoa(e.target.result).replace(/\n/g,'')};
        that.binFiles.push(fElement);
        that.numFiles++;
      };
    })(file);

    reader.readAsBinaryString(file);
  }

  checkFilesUploading = () => {  
    let allowedExt = {'JPEG': 1, 'JPG': 1, 'PNG': 1, 'GIF':1}
    var fileExt = this.binFiles[0].name.split('.')[1].toUpperCase();
    console.log("DDDD1",this.binFiles[0].name.split('.')[1].toUpperCase())
    var stringLength = this.binFiles[0].bin_file.length; //- 'data:image/png;base64,'.length
    var sizeInBytes = 4 * Math.ceil((stringLength / 3))*0.5624896334383812;
    var sizeInKb=sizeInBytes/1024;
    var sizeInKbRounded = (Math.round(sizeInKb * 100) / 100).toFixed(2)
    console.log("sizeInKbRounded", sizeInKbRounded);
    if(sizeInKbRounded > 500)
    {
      this.props.onFilesAddedSizeExceed();
      this.binFiles = [];  
    }else if(!(fileExt in allowedExt )){
      this.props.onFilesAddedExtNotMatched();
      this.binFiles = []; 
    }else{
      var confirm = window.confirm('Your profile picture will be changed. Are you sure?');
      if(confirm == true){
        this.props.onFilesAdded(this.binFiles);
        this.binFiles =[];  
      }
    }    
  }

  onFilesAdded(evt) { 
    const files = evt.target.files;
    setTimeout(this.checkFilesUploading, 500);
    for (var i = 0; i < files.length; i++) {
      this.readBinaryFile(files.item(i));
    }
  }

  componentDidMount() {
    var profile_image = this.props.ProfilePicture.replace(/ /g, '+') == '' ? default_profile_pic : 'data:image/png;base64,'+ this.props.ProfilePicture.replace(/ /g, '+');
    /*if(profile_image !='' && !Store.getStoreData('is_debug')){
      document.getElementById("imagebox").setAttribute('src' , profile_image);
      document.getElementById("imagebox_logout").setAttribute('src' , profile_image);
    }*/
    this.setState({image_bin : profile_image});
  }
  componentDidUpdate(prevProps) {   
    if (prevProps !== this.props) {
      var profile_image = this.props.ProfilePicture.replace(/ /g, '+') == '' ? default_profile_pic : 'data:image/png;base64,'+ this.props.ProfilePicture.replace(/ /g, '+');
      /*if(profile_image !='' && !Store.getStoreData('is_debug')){  
        document.getElementById("imagebox").setAttribute('src' , profile_image);
        document.getElementById("imagebox_logout").setAttribute('src' , profile_image);
      }*/
      this.setState({image_bin : profile_image});
    }
  }
  render() {
    
    return (
      <div style={{width: "88%"}}>
           <div
              className={`Dropzone ${this.state.hightlight ? "Highlight" : ""}`}
              style={{paddingTop:'2px', display:'flex', width: '51%', height:"270px", backgroundColor: "#ffffff"}}
            >
              <input
              ref={this.fileInputRef}
              className="FileInput"
              type="file"
              multiple
              accept=".jpg,.jpeg,.png"
              onChange={this.onFilesAdded}
              onMouseOver={this.onHover}
              />
              <img src= {this.state.image_bin} alt= "Profile Picture" width="270px" height= "100%" onClick={this.openFileDialog} style={{ borderRadius: "50%" , cursor: this.props.disabled ? "default" : "pointer", fontSize:"14px"}}/>
          
          </div>
          <UploadButton onClick={this.openFileDialog}>Upload</UploadButton>
      </div>
   
    );
  }
}

export default Dropzone;